import { generalConstants } from "./../constants";

/**
 * Side open/close
 *
 * @returns {{type: string}}
 */
export const siderToggle = (collapsed) => {
	return {
		type: generalConstants.SIDER_TOGGLE,
		data: {
			collapsed,
		}
	}
};
